import axios from 'axios';
import { stringify } from 'qs';

import config from '../Config';

const WebSearchApi = axios.create({
  baseURL: config.webSearchApiUrl || 'https://www.telia.ee/search/api',
  timeout: 20000,
  paramsSerializer: { serialize: (params) => stringify(params, { arrayFormat: 'repeat' }) },
  withCredentials: false
});

export default WebSearchApi;
